import React, { useState, useContext } from "react";

import {
  Button,
  CssBaseline,
  TextField,
  Box,
  Container,
  InputAdornment,
  IconButton,
  Paper,
} from '@material-ui/core';

import { Visibility, VisibilityOff } from '@material-ui/icons';

import { makeStyles } from "@material-ui/core/styles";

import { i18n } from "../../translate/i18n";

import { AuthContext } from "../../context/Auth/AuthContext";

// const Copyright = () => {
// 	return (
// 		<Typography variant="body2" color="textSecondary" align="center">
// 			{"Copyleft "}
// 			<Link color="inherit" href="https://github.com/canove">
// 				Canove
// 			</Link>{" "}
// 			{new Date().getFullYear()}
// 			{"."}
// 		</Typography>
// 	);
// };

const useStyles = makeStyles((theme) => ({
  loginRoot: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4, 2),
    backgroundImage:
      "radial-gradient(circle at 8% 10%, rgba(56,189,248,0.2), transparent 40%), radial-gradient(circle at 85% 20%, rgba(21,184,166,0.2), transparent 45%)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(2, 1),
    },
  },
  card: {
    padding: theme.spacing(4),
    borderRadius: 20,
    boxShadow: "0 24px 60px rgba(15, 23, 42, 0.16)",
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3, 2),
      borderRadius: 16,
    },
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  logoWrap: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(3),
    },
  },
  logo: {
    height: 120,
    maxWidth: 360,
    width: "100%",
    objectFit: "contain",
    display: "block",
    [theme.breakpoints.down("sm")]: {
      height: 96,
      maxWidth: 280,
    },
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const Login = () => {
  const classes = useStyles();

  const [user, setUser] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  const { handleLogin } = useContext(AuthContext);

  const handleChangeInput = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handlSubmit = (e) => {
    e.preventDefault();
    handleLogin(user);
  };

  return (
    <div className={classes.loginRoot}>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <Paper className={classes.card} elevation={6}>
          <div className={classes.paper}>
            <div className={classes.logoWrap}>
              <img
                src={`${process.env.PUBLIC_URL}/logo-gonelogin.png`}
                alt="WhatsContábil"
                className={classes.logo}
              />
            </div>
            <form className={classes.form} noValidate onSubmit={handlSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="email"
                label={i18n.t("login.form.email")}
                name="email"
                value={user.email}
                onChange={handleChangeInput}
                autoComplete="email"
                autoFocus
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="password"
                label={i18n.t("login.form.password")}
                id="password"
                value={user.password}
                onChange={handleChangeInput}
                autoComplete="current-password"
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={() => setShowPassword((e) => !e)}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                size="large"
              >
                {i18n.t("login.buttons.submit")}
              </Button>
              {/*<Grid container>
                <Grid item>
                  <Link
                    href="#"
                    variant="body2"
                    component={RouterLink}
                    to="/signup"
                  >
                    {i18n.t("login.buttons.register")}
                  </Link>
                </Grid>
              </Grid>*/}
            </form>
          </div>
        </Paper>
        <Box mt={6}>{/* <Copyright /> */}</Box>
      </Container>
    </div>
  );
};

export default Login;

